import styled from '@emotion/styled'
import * as React from 'react'

import { colors, NativeLink, Text } from 'main/ui'

interface IProps {
  onRequestLogin: () => void
}

const ErrorText = styled(Text)`
  color: ${colors.text.error};
`

export default function EmailExistsError(props: IProps) {
  const { onRequestLogin } = props

  return (
    <div>
      <div>
        <ErrorText>An account with this email address already exists.</ErrorText>
      </div>
      <div>
        <ErrorText>Try&nbsp;</ErrorText>
        <NativeLink onClick={() => onRequestLogin()}>logging in</NativeLink>
        <ErrorText>&nbsp;instead.</ErrorText>
      </div>
    </div>
  )
}
